import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  Unit_instance104q5opgivhr8 as Unit_instance,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  CancellationException3b36o9qz53rgr as CancellationException,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  Result3t1vadv16kmzk as Result,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  getKClass1s3j9wy1cofik as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  Unitkvevlwgzwiuc as Unit,
  isInterface3d6p8outrmvmk as isInterface,
  getValue48kllevslyh6 as getValue,
  equals2au1ep9vhcato as equals,
  _Result___get_isSuccess__impl__sndoy82z6txcyihce8z as _Result___get_isSuccess__impl__sndoy8,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap_init_$Create$7ps311k1ff73 as LinkedHashMap_init_$Create$,
  emptyList1g2z5xcrvp2zy as emptyList,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance35hsivaslc5e3 as Companion_getInstance,
  ApiVersion_JULY_2026_getInstance26s1g5r9ct27x as ApiVersion_JULY_2026_getInstance,
  buildV2Path1ie1ylvss3rsk as buildV2Path,
  mapApiErrorResponse18m737xo6p7hy as mapApiErrorResponse,
  get_sharedJson2ja82jrdlkmvt as get_sharedJson,
  Clientssjxb7gh2u6y as Client,
} from './Shared7Punches-infrastructure-network.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  url2l6iw5ri21nxb as url,
  headers24pki7ce1busg as headers,
  HttpStatement3zxb33q8lku as HttpStatement,
} from './ktor-ktor-client-ktor-client-core.mjs';
import { Companion_getInstancepumzx9q4106p as Companion_getInstance_0 } from './ktor-ktor-http.mjs';
import {
  Companion_instance38at02i5wbrbj as Companion_instance_0,
  UnexpectedApiResponse11rd45rhjxm6r as UnexpectedApiResponse,
  SimpleValueEndpointCacheStrategy2snxed6lorji8 as SimpleValueEndpointCacheStrategy,
  ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider,
  SessionBasedCache2ygh1ov6l3auc as SessionBasedCache,
} from './Shared7Punches-common-base.mjs';
import {
  JsonElementf07o4p6p57al as JsonElement,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from './ktor-ktor-utils.mjs';
import {
  serializer1hwzc6m64v1op as serializer,
  KSerializerzf77vz1967fq as KSerializer,
  LIST_getInstance3iji3zetpdcxm as LIST_getInstance,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$1mnsp66c6fnup as UnknownFieldException_init_$Create$,
  BooleanSerializer_getInstancet3wtk7fl7i4f as BooleanSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  get_entriesvfuvsm248cwl as get_entries,
  IPlanFeatureAccessor1c22ybcggkrw as IPlanFeatureAccessor,
} from './Shared7Punches-business-domains-billing-domain.mjs';
import {
  named1qn5s3wnxjwbv as named,
  Companion_getInstance1rlvzabi952im as Companion_getInstance_1,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import {
  ICache3bwileb79diof as ICache,
  InMemoryCache2v1xems7p2diw as InMemoryCache,
  CacheCleanerRegistry1txtxriyqr3kw as CacheCleanerRegistry,
} from './Shared7Punches-infrastructure-cache.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForInterface(IPlanFeatureRemoteSource, 'IPlanFeatureRemoteSource', VOID, VOID, VOID, [1]);
initMetadataForCoroutine($isPlanFeatureEnabledCOROUTINE$0, CoroutineImpl);
initMetadataForClass(PlanFeatureRemoteSource, 'PlanFeatureRemoteSource', VOID, VOID, [IPlanFeatureRemoteSource], [1]);
initMetadataForLambda(PlanFeatureRepository$strategies$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(PlanFeatureRepository$strategies$slambda_1, CoroutineImpl, VOID, [0]);
initMetadataForClass(PlanFeatureRepository, 'PlanFeatureRepository', VOID, VOID, [IPlanFeatureAccessor]);
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiHasFeature, 'ApiHasFeature', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
//endregion
function IPlanFeatureRemoteSource() {
}
function PlanFeatureRemoteSource$isPlanFeatureEnabled$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function PlanFeatureRemoteSource$isPlanFeatureEnabled$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $isPlanFeatureEnabledCOROUTINE$0(_this__u8e3s4, feature, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.d9w_1 = _this__u8e3s4;
  this.e9w_1 = feature;
}
protoOf($isPlanFeatureEnabledCOROUTINE$0).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 13;
          this.n8_1 = 1;
          suspendResult = this.d9w_1.z9x_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.f9w_1 = suspendResult;
          var tmp_0 = this;
          tmp_0.g9w_1 = this.d9w_1.y9x_1;
          var tmp_1 = this;
          tmp_1.h9w_1 = 'company/' + this.f9w_1.toString() + '/features/' + this.e9w_1.v37_1;
          var tmp_2 = this;
          tmp_2.i9w_1 = ApiVersion_JULY_2026_getInstance();
          this.j9w_1 = this.g9w_1;
          this.k9w_1 = this.h9w_1;
          this.l9w_1 = this.i9w_1;
          var tmp_3 = this;
          tmp_3.m9w_1 = PlanFeatureRemoteSource$isPlanFeatureEnabled$lambda;
          this.o8_1 = 3;
          var tmp_4 = this;
          tmp_4.o9w_1 = Companion_instance;
          var tmp_5 = this;
          tmp_5.p9w_1 = this.j9w_1.f6l_1;
          var tmp_6 = this;
          tmp_6.q9w_1 = buildV2Path(this.j9w_1, this.k9w_1);
          this.r9w_1 = this.p9w_1;
          this.s9w_1 = this.q9w_1;
          var tmp_7 = this;
          tmp_7.t9w_1 = this.r9w_1;
          this.u9w_1 = this.t9w_1;
          var tmp_8 = this;
          tmp_8.v9w_1 = this.u9w_1;
          var tmp_9 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.s9w_1);
          headers(this_0, PlanFeatureRemoteSource$isPlanFeatureEnabled$lambda_0(this.l9w_1));
          this_0.z5n(this.m9w_1);
          tmp_9.w9w_1 = this_0;
          this.x9w_1 = this.v9w_1;
          this.y9w_1 = this.w9w_1;
          this.y9w_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_10 = this;
          tmp_10.z9w_1 = this.x9w_1;
          var tmp_11 = this;
          tmp_11.a9x_1 = this.y9w_1;
          this.b9x_1 = this.z9w_1;
          this.c9x_1 = this.a9x_1;
          this.n8_1 = 2;
          suspendResult = (new HttpStatement(this.c9x_1, this.b9x_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.d9x_1 = suspendResult;
          var tmp_12 = this;
          this.o9w_1;
          var value = this.d9x_1;
          tmp_12.n9w_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 13;
          this.n8_1 = 4;
          continue $sm;
        case 3:
          this.o8_1 = 13;
          var tmp_13 = this.q8_1;
          if (tmp_13 instanceof CancellationException) {
            this.e9x_1 = this.q8_1;
            var tmp_14 = this;
            throw this.e9x_1;
          } else {
            var tmp_15 = this.q8_1;
            if (tmp_15 instanceof Error) {
              this.f9x_1 = this.q8_1;
              var tmp_16 = this;
              var exception = this.f9x_1;
              tmp_16.n9w_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          this.o8_1 = 13;
          this.g9x_1 = this.n9w_1;
          this.h9x_1 = this.g9x_1;
          this.i9x_1 = Result__exceptionOrNull_impl_p6xea9(this.h9x_1);
          if (this.i9x_1 == null) {
            var tmp_17 = this;
            var tmp_18 = _Result___get_value__impl__bjfvqg(this.h9x_1);
            tmp_17.k9x_1 = (tmp_18 == null ? true : !(tmp_18 == null)) ? tmp_18 : THROW_CCE();
            this.l9x_1 = this.k9x_1;
            var tmp_19 = this;
            tmp_19.m9x_1 = this.l9x_1;
            this.n9x_1 = this.m9x_1;
            this.o9x_1 = this.n9x_1.c4u().z43_1;
            var containsArg = this.o9x_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 9;
              var tmp_20 = this;
              tmp_20.r9x_1 = Companion_instance;
              if (getKClass(ApiHasFeature).equals(getKClass(Unit))) {
                var tmp_21 = this;
                tmp_21.t9x_1 = this.n9x_1;
                this.u9x_1 = this.t9x_1;
                this.n8_1 = 7;
                var tmp_22 = this.u9x_1.y4u();
                var tmp_23 = getKClass(ApiHasFeature);
                var tmp_24;
                try {
                  tmp_24 = createKType(getKClass(ApiHasFeature), arrayOf([]), false);
                } catch ($p) {
                  var tmp_25;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_25 = null;
                  } else {
                    throw $p;
                  }
                  tmp_24 = tmp_25;
                }
                suspendResult = tmp_22.a4u(new TypeInfo(tmp_23, tmp_24), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_26 = this;
                tmp_26.v9x_1 = this.n9x_1;
                this.w9x_1 = this.v9x_1;
                this.n8_1 = 6;
                var tmp_27 = this.w9x_1.y4u();
                var tmp_28 = getKClass(JsonElement);
                var tmp_29;
                try {
                  tmp_29 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_30;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_30 = null;
                  } else {
                    throw $p;
                  }
                  tmp_29 = tmp_30;
                }
                suspendResult = tmp_27.a4u(new TypeInfo(tmp_28, tmp_29), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_31 = this;
              tmp_31.x9x_1 = Companion_instance;
              this.n8_1 = 5;
              suspendResult = mapApiErrorResponse(this.n9x_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_32 = this;
            var it = this.i9x_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_32.j9x_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 12;
            continue $sm;
          }

        case 5:
          var tmp4 = suspendResult;
          var tmp_33 = this;
          this.x9x_1;
          tmp_33.p9x_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 11;
          continue $sm;
        case 6:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_34 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiHasFeature), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_35;
            if (tmp2 instanceof JsonObject) {
              tmp_35 = tmp2.c3p('data');
            } else {
              tmp_35 = false;
            }
            if (tmp_35) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_36;
              if (dataValue instanceof JsonObject) {
                tmp_36 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_36 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_36 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_36;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_34.s9x_1 = tmp$ret$0;
          this.n8_1 = 8;
          continue $sm;
        case 7:
          var tmp_37 = this;
          tmp_37.s9x_1 = suspendResult instanceof ApiHasFeature ? suspendResult : THROW_CCE();
          this.n8_1 = 8;
          continue $sm;
        case 8:
          var tmp1 = this.s9x_1;
          var tmp_38 = this;
          this.r9x_1;
          tmp_38.q9x_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 13;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          this.o8_1 = 13;
          var tmp_39 = this.q8_1;
          if (tmp_39 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_40 = this;
            throw e_0;
          } else {
            var tmp_41 = this.q8_1;
            if (tmp_41 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_42 = this;
              tmp_42.q9x_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 10;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 10:
          this.o8_1 = 13;
          var tmp_43 = this;
          var this_2 = this.q9x_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_44;
          if (exception_1 == null) {
            var tmp_45 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_45 == null ? true : !(tmp_45 == null)) ? tmp_45 : THROW_CCE();
            tmp_44 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_44 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_43.p9x_1 = tmp_44.ul_1;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          this.j9x_1 = new Result(this.p9x_1);
          this.n8_1 = 12;
          continue $sm;
        case 12:
          var this_3 = this.j9x_1.ul_1;
          var tmp_46;
          if (_Result___get_isSuccess__impl__sndoy8(this_3)) {
            var tmp_47 = _Result___get_value__impl__bjfvqg(this_3);
            var value_1 = ((tmp_47 == null ? true : !(tmp_47 == null)) ? tmp_47 : THROW_CCE()).a9y_1;
            tmp_46 = _Result___init__impl__xyqfz8(value_1);
          } else {
            tmp_46 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_3));
          }

          return new Result(tmp_46);
        case 13:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 13) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function PlanFeatureRemoteSource(apiClient, sessionDataProvider) {
  this.y9x_1 = apiClient;
  this.z9x_1 = sessionDataProvider;
}
protoOf(PlanFeatureRemoteSource).u9v = function (feature, $completion) {
  var tmp = new $isPlanFeatureEnabledCOROUTINE$0(this, feature, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function PlanFeatureRepository$strategies$slambda(this$0, $feature, resultContinuation) {
  this.j9y_1 = this$0;
  this.k9y_1 = $feature;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(PlanFeatureRepository$strategies$slambda).m9y = function (it, $completion) {
  var tmp = this.n9y(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(PlanFeatureRepository$strategies$slambda).h9 = function (p1, $completion) {
  return this.m9y((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(PlanFeatureRepository$strategies$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.j9y_1.p9y_1.i2a(this.k9y_1.v37_1, this.l9y_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(PlanFeatureRepository$strategies$slambda).n9y = function (it, completion) {
  var i = new PlanFeatureRepository$strategies$slambda(this.j9y_1, this.k9y_1, completion);
  i.l9y_1 = it;
  return i;
};
function PlanFeatureRepository$strategies$slambda_0(this$0, $feature, resultContinuation) {
  var i = new PlanFeatureRepository$strategies$slambda(this$0, $feature, resultContinuation);
  var l = function (it, $completion) {
    return i.m9y(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function PlanFeatureRepository$strategies$slambda_1(this$0, $feature, resultContinuation) {
  this.z9y_1 = this$0;
  this.a9z_1 = $feature;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(PlanFeatureRepository$strategies$slambda_1).b9z = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(PlanFeatureRepository$strategies$slambda_1).ma = function ($completion) {
  return this.b9z($completion);
};
protoOf(PlanFeatureRepository$strategies$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.z9y_1.o9y_1.u9v(this.a9z_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(PlanFeatureRepository$strategies$slambda_1).m32 = function (completion) {
  return new PlanFeatureRepository$strategies$slambda_1(this.z9y_1, this.a9z_1, completion);
};
function PlanFeatureRepository$strategies$slambda_2(this$0, $feature, resultContinuation) {
  var i = new PlanFeatureRepository$strategies$slambda_1(this$0, $feature, resultContinuation);
  var l = function ($completion) {
    return i.b9z($completion);
  };
  l.$arity = 0;
  return l;
}
function PlanFeatureRepository$strategies$lambda(it) {
  return it;
}
function PlanFeatureRepository(remoteSource, cache) {
  this.o9y_1 = remoteSource;
  this.p9y_1 = cache;
  var tmp = this;
  // Inline function 'kotlin.collections.associateWith' call
  var this_0 = get_entries();
  var result = LinkedHashMap_init_$Create$(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp_0 = this.p9y_1.h2a(element.v37_1);
    var tmp_1 = PlanFeatureRepository$strategies$slambda_0(this, element, null);
    var tmp_2 = PlanFeatureRepository$strategies$slambda_2(this, element, null);
    var tmp$ret$0 = new SimpleValueEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, PlanFeatureRepository$strategies$lambda);
    result.h2(element, tmp$ret$0);
  }
  tmp.q9y_1 = result;
}
function get_billingDataModule() {
  _init_properties_BillingDataModule_kt__z00t27();
  return billingDataModule;
}
var billingDataModule;
function billingDataModule$lambda($this$module) {
  _init_properties_BillingDataModule_kt__z00t27();
  var tmp1 = named('plan_feature_cache');
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = billingDataModule$lambda$lambda;
  var scopeQualifier = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Singleton_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(ICache), tmp1, definition, kind, secondaryTypes);
  var factory = new SingleInstanceFactory(def);
  $this$module.p1c(factory);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory);
  }
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = billingDataModule$lambda$lambda_0;
  var scopeQualifier_0 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Singleton_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(IPlanFeatureRemoteSource), null, definition_0, kind_0, secondaryTypes_0);
  var factory_0 = new SingleInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_0);
  }
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_1 = billingDataModule$lambda$lambda_1;
  var scopeQualifier_1 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Singleton_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(IPlanFeatureAccessor), null, definition_1, kind_1, secondaryTypes_1);
  var factory_1 = new SingleInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_1);
  }
  new KoinDefinition($this$module, factory_1);
  return Unit_instance;
}
function billingDataModule$lambda$lambda($this$single, it) {
  _init_properties_BillingDataModule_kt__z00t27();
  var tmp = new InMemoryCache();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$single.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$single.q1d(getKClass(CacheCleanerRegistry), null, null);
  return new SessionBasedCache(tmp, tmp_0, tmp$ret$1);
}
function billingDataModule$lambda$lambda_0($this$single, it) {
  _init_properties_BillingDataModule_kt__z00t27();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$single.q1d(getKClass(ISessionDataProvider), null, null);
  return new PlanFeatureRemoteSource(tmp, tmp$ret$1);
}
function billingDataModule$lambda$lambda_1($this$single, it) {
  _init_properties_BillingDataModule_kt__z00t27();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IPlanFeatureRemoteSource), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = named('plan_feature_cache');
  var tmp$ret$1 = $this$single.q1d(getKClass(ICache), qualifier, null);
  return new PlanFeatureRepository(tmp, tmp$ret$1);
}
var properties_initialized_BillingDataModule_kt_4xau3l;
function _init_properties_BillingDataModule_kt__z00t27() {
  if (!properties_initialized_BillingDataModule_kt_4xau3l) {
    properties_initialized_BillingDataModule_kt_4xau3l = true;
    billingDataModule = module_0(VOID, billingDataModule$lambda);
  }
}
function Companion() {
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.business_domains.billing.data.models.ApiHasFeature', this, 1);
  tmp0_serialDesc.wy('enabled', false);
  this.c9z_1 = tmp0_serialDesc;
}
protoOf($serializer).d9z = function (encoder, value) {
  var tmp0_desc = this.c9z_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.rs(tmp0_desc, 0, value.a9y_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer).yn = function (encoder, value) {
  return this.d9z(encoder, value instanceof ApiHasFeature ? value : THROW_CCE());
};
protoOf($serializer).zn = function (decoder) {
  var tmp0_desc = this.c9z_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = false;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.mr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.mr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiHasFeature_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer).xn = function () {
  return this.c9z_1;
};
protoOf($serializer).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [BooleanSerializer_getInstance()];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function ApiHasFeature_init_$Init$(seen0, enabled, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance().c9z_1);
  }
  $this.a9y_1 = enabled;
  return $this;
}
function ApiHasFeature_init_$Create$(seen0, enabled, serializationConstructorMarker) {
  return ApiHasFeature_init_$Init$(seen0, enabled, serializationConstructorMarker, objectCreate(protoOf(ApiHasFeature)));
}
function ApiHasFeature(enabled) {
  this.a9y_1 = enabled;
}
protoOf(ApiHasFeature).toString = function () {
  return 'ApiHasFeature(enabled=' + this.a9y_1 + ')';
};
protoOf(ApiHasFeature).hashCode = function () {
  return getBooleanHashCode(this.a9y_1);
};
protoOf(ApiHasFeature).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiHasFeature))
    return false;
  var tmp0_other_with_cast = other instanceof ApiHasFeature ? other : THROW_CCE();
  if (!(this.a9y_1 === tmp0_other_with_cast.a9y_1))
    return false;
  return true;
};
//region block: post-declaration
protoOf($serializer).qz = typeParametersSerializers;
//endregion
//region block: init
Companion_instance_1 = new Companion();
//endregion
//region block: exports
export {
  get_billingDataModule as get_billingDataModule1upx3kww23zej,
};
//endregion

